/*
 * Purpose: Root app shell — routing, theme, and global providers
 * Last modified: 2026-06-25 | Agent
 * Completeness: 90
 */
import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { ThemeProvider } from "@/components/theme-provider";
import { DesignStyleProvider } from "@/components/design-style-provider";
import { DesignStyleToggle } from "@/components/design-style-toggle";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import Help from "./pages/Help";
import Dashboard from "./pages/Dashboard";
import NotFound from "./pages/NotFound";
import WorkflowBuilder from "./pages/WorkflowBuilder";
import ComposePage from "./pages/Compose";
import Setup from "./pages/Setup";
import LinkedInOAuthCallback from "./pages/LinkedInOAuthCallback";

const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider defaultTheme="system" storageKey="workflow-ui-theme">
        <DesignStyleProvider>
        <TooltipProvider>
          <Toaster />
          <DesignStyleToggle />
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Index />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/help" element={<Help />} />
              <Route path="/compose" element={<ComposePage />} />
              <Route path="/setup" element={<Setup />} />
              <Route path="/oauth/linkedin/callback" element={<LinkedInOAuthCallback />} />
              <Route path="/builder" element={<WorkflowBuilder />} />
              {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </BrowserRouter>
        </TooltipProvider>
        </DesignStyleProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}

export default App;